import React from 'react';

export type Props = React.SVGProps<SVGSVGElement>;

export type logoTypes = 'notifi' | 'notifi-text';

export const Logo: React.FC<Props & { type: logoTypes }> = (
  props: Props & { type: logoTypes },
) => {
  switch (props.type) {
    case 'notifi':
      return (
        <svg
          {...props}
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="9"
          viewBox="0 0 10 9"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.92661 5.02546C7.68505 5.09424 7.43002 5.13107 7.16639 5.13107C5.63641 5.13107 4.39611 3.89077 4.39611 2.36079C4.39611 2.08776 4.43561 1.82397 4.50919 1.5748H1.63872C1.19751 1.5748 0.839844 1.93247 0.839844 2.37367V7.86269C0.839844 8.3039 1.19751 8.66156 1.63872 8.66156H7.12774C7.56894 8.66156 7.92661 8.3039 7.92661 7.86269V5.02546Z"
            fill="currentColor"
          />
          <path
            d="M9.50142 1.96852C9.50142 3.05571 8.62007 3.93706 7.53288 3.93706C6.44568 3.93706 5.56433 3.05571 5.56433 1.96852C5.56433 0.881317 6.44568 -3.05176e-05 7.53288 -3.05176e-05C8.62007 -3.05176e-05 9.50142 0.881317 9.50142 1.96852Z"
            fill="url(#paint0_linear_4504_6143)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_4504_6143"
              x1="8.72167"
              y1="0.306756"
              x2="6.82982"
              y2="3.93706"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FE7970" />
              <stop offset="1" stopColor="#FEB776" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 'notifi-text':
      return (
        <svg
          {...props}
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="9"
          viewBox="0 0 26 9"
          fill="none"
        >
          <path
            d="M4.90313 5.61341V8.60201H6.14424V5.61341C6.14424 3.77656 5.19107 2.57516 3.68187 2.57516C2.94713 2.57516 2.29183 3.01203 2.07339 3.6177V2.64466H0.832275V8.60201H2.07339V5.62334C2.07339 4.57087 2.6592 3.81627 3.46344 3.81627C4.33718 3.81627 4.90313 4.52123 4.90313 5.61341Z"
            fill="currentColor"
          />
          <path
            d="M6.97375 5.61341C6.97375 7.34104 8.25458 8.66158 9.90278 8.66158C11.551 8.66158 12.8219 7.34104 12.8219 5.61341C12.8219 3.8957 11.551 2.57516 9.90278 2.57516C8.25458 2.57516 6.97375 3.8957 6.97375 5.61341ZM9.90278 3.81627C10.856 3.81627 11.5808 4.59073 11.5808 5.61341C11.5808 6.64601 10.856 7.42047 9.90278 7.42047C8.94961 7.42047 8.21487 6.64601 8.21487 5.61341C8.21487 4.59073 8.94961 3.81627 9.90278 3.81627Z"
            fill="currentColor"
          />
          <path
            d="M14.5834 1.38368L14.2855 2.64466H13.4019V3.81627H14.2855V6.55665C14.2855 8.0162 14.8813 8.60201 16.3011 8.60201H16.8174V7.37082H16.4203C15.8047 7.37082 15.5267 7.10274 15.5267 6.48715V3.81627H16.8174V2.64466H15.5267V1.38368H14.5834Z"
            fill="currentColor"
          />
          <path
            d="M18.9217 8.60201V2.64466H17.6806V8.60201H18.9217Z"
            fill="currentColor"
          />
          <path
            d="M25.2799 8.60201V2.64466H21.8644V2.20779C21.8644 1.5922 22.1424 1.31418 22.758 1.31418H23.1551V0.092926H22.6388C21.219 0.092926 20.6233 0.668808 20.6233 2.13829V2.64466H19.7495V3.81627H20.6233V8.60201H21.8644V3.81627H24.0388V8.60201H25.2799Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1574 -3.05176e-05C17.8067 -3.05176e-05 17.6805 0.192456 17.6805 0.466205V1.46136H18.6536C18.9915 1.46136 19.1419 1.34306 19.1419 1.00943V0.466205C19.1419 0.15396 18.9359 -3.05176e-05 18.6194 -3.05176e-05H18.1574Z"
            fill="currentColor"
          />
        </svg>
      );
    default:
      return null;
  }
};
